export const Drawer = {
    baseStyle: {},
    sizes: {},
    variants: {
        standard: {
            overlay: {},
            dialogContainer: {},
            body: {},
        },
        custom: {
            dialog: {},
            body: {},
        },
    },
    defaultProps: {
        size: "md",
        variant: "standard",
    },
};
